import { render, staticRenderFns } from "./po_changes.vue?vue&type=template&id=04033a62&scoped=true&lang=html&"
import script from "./po_changes.vue?vue&type=script&lang=js&"
export * from "./po_changes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04033a62",
  null
  
)

export default component.exports